<template>
  <div class="content">
    <!-- 支付宝 -->
    <div
      class="alipay"
      v-if="active == 1"
    >
      <div class="tap">
        <div class="tap-active">
          <div>挚达支付宝小程序</div>
        </div>
        <div @click="selectAPP">挚达APP</div>
      </div>
    </div>
    <div
      class="app"
      v-else
    >
      <div class="tap">
        <div
          @click="selectAli"
          style="display: flex; align-items: center; justify-content: center"
        >
          <div>挚达支付宝小程序</div>
        </div>
        <div class="tap-active">挚达APP</div>
      </div>
      <div
        class="androload"
        @click="goAndro"
      ></div>
      <div
        class="iosload"
        @click="goIos"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 1,
    };
  },
  methods: {
    selectAPP() {
      this.active = 2;
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动
      });
    //   this.countByApp()
    },
    selectAli() {
      this.active = 1;
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动
      });
    },
    goAndro() {
      window.open("https://sj.qq.com/appdetail/com.shzhida.zd?from_wxz=1");
    },
    goIos() {
      window.open(
        "https://apps.apple.com/cn/app/%E6%8C%9A%E8%BE%BE/id6444815321"
      );
    },
    // 支付宝浏览统计
    countByAli() {
      let that = this;
      that.$H
        .post(
          that,
          "/v6/api/d1/aliMiniPro/open/pageViewCountNew",
          {
            pageType: "B_TYPE",
            channel: 15,
            operationStep: 1,
          }
        )
        .then((res) => {});
    },
    // app 浏览统计
    countByApp() {
      let that = this;
      that.$H
        .post(
          that,
          "/v6/api/d1/aliMiniPro/open/pageViewCountNew",
          {
            pageType: "B_TYPE",
            channel: 16,
            operationStep: 1,
          }
        )
        .then((res) => {});
    },
  },
  mounted() {
    // this.countByAli()
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  //   height: 100%;
  background-image: url("https://img.cdn.wxzhida.cn/zd-ali-app/welcome-bg.png");
  background-size: 100% auto;
  padding-top: 246px;
  background-color: #1a2029;
  //   border: 1px solid red;

  .alipay {
    width: 345px;
    height: 2542px;
    background: url("https://img.cdn.wxzhida.cn/zd-ali-app/kkooppcc.png");
    background-size: 100% 100%;
    margin: 0 auto;
    padding-top: 10px;

    .tap {
      width: 325px;
      height: 50px;
      background: #404e65;
      border-radius: 27px;
      margin: 0 auto;
      position: sticky;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: space-around;
      z-index: 1000;
      > div {
        height: 44px;
        width: 158px;
        font-weight: bold;
        font-size: 14px;
        color: #58bdff;
        line-height: 44px;
        text-align: center;
      }

      .tap-active {
        background: url("https://img.cdn.wxzhida.cn/zd-ali-app/ali-zd.png");
        background-size: 100% 100%;
        font-weight: bold;
        font-size: 14px;
        color: #1677ff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .gift {
        width: 14px;
        height: 13px;
        background: url("https://img.cdn.wxzhida.cn/zd-ali-app/%E7%A4%BC%E7%89%A9%402x.png");
        background-size: 100% 100%;
        margin-left: 3px;
      }
    }
  }

  .app {
    width: 345px;
    height: 2067px;
    background: url("https://img.cdn.wxzhida.cn/zd-ali-app/kkooppccr.png");
    background-size: 100% 100%;
    margin: 0 auto;
    padding-top: 10px;

    .tap {
      width: 325px;
      height: 50px;
      background: #404e65;
      border-radius: 27px;
      margin: 0 auto;
      position: sticky;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: space-around;

      > div {
        height: 44px;
        width: 158px;
        font-weight: bold;
        font-size: 14px;
        color: #58bdff;
        line-height: 44px;
        text-align: center;
      }

      .tap-active {
        background: url("https://img.cdn.wxzhida.cn/zd-ali-app/zd-logos.png");
        background-size: 100% 100%;
        font-weight: bold;
        font-size: 14px;
        color: #1677ff;
      }
      .gift {
        width: 14px;
        height: 13px;
        background: url("https://img.cdn.wxzhida.cn/zd-ali-app/%E7%A4%BC%E7%89%A9%402x.png");
        background-size: 100% 100%;
        margin-left: 3px;
      }
    }

    .androload {
      position: absolute;
      top: 565px;
      left: 55px;
      width: 140px;
      height: 35px;
      border: 0.5px solid transparent;
    }

    .iosload {
      position: absolute;
      top: 565px;
      left: 210px;
      width: 140px;
      height: 35px;
      border: 0.5px solid transparent;
    }
  }
}
</style>
